import React, { useEffect, useState } from "react";
import DeleteDataModel from "./DeleteDataModel";
import { LIcon } from "assests/GmsIcons";
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TTransformation, TUpsertISRProjectDataModelsInput,} from "../model";
import { CALCULATED, PRODUCT_CATEGORY, TRANSFORMATION,} from "Pages/GMS/ISR/ISRConstants";

type TProductCategoryItemProps = {
  id: string;
  field?: TProductCategory;
  fieldName: string;
  fieldType: string;
  classColor?: string;
  isSelected: boolean;
  onSelect: () => void;
  indexInfo: TIndexState;
  isSubSelected?: boolean;
  onSubSelect?: () => void;
  showCalculatedField?: boolean;
  onDelete: (fieldName: string|null|undefined) => void;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  setIndex?: React.Dispatch<React.SetStateAction<TIndexState>>;
  setSubSelectedItem: React.Dispatch<React.SetStateAction<TTransformation | null>>;
  selectedItem: | TField | TSubmodel | TProductCategory | TConnector | TTransformation | null;
  setUserProjectDataModels?: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
  onSubDelete: (categoryId: string, transformationId:string) => void;
};

const ProductCategoryItem = ({
  id,
  field,
  fieldName,
  fieldType,
  onDelete,
  isSelected,
  onSelect,
  selectedItem,
  userProjectDataModels,
  indexInfo,
  showCalculatedField,
  classColor,
  setSubSelectedItem,
  setIndex,
  setUserProjectDataModels,
  onSubDelete
}: TProductCategoryItemProps) => {
  const [name, setName] = useState<string>("");
  const [subSelected, setSubSelected] = useState<any>(indexInfo?.TransformationIndex);
  const handleContextMenuOptionClick = () => {
    onDelete(field?.id);
  };
  const handleContextMenuTransformationOptionClick = (transformationId:string) => {
    onSubDelete(field?.id as string, transformationId);
  };
  useEffect(() => {
    if (
      selectedItem &&
      "belongsToDataModel" in selectedItem &&
      selectedItem?.belongsToDataModel
    ) {
      setName(
        userProjectDataModels?.project.dataModels[
          indexInfo?.dataModelIndex ?? -1
        ]?.data.fields[indexInfo?.fieldIndex ?? -1].type ?? ""
      );
    } else {
      setName(
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data?.type ?? ""
      );
    }
  }, [selectedItem]);

  useEffect(()=>{
    setSubSelected(indexInfo?.TransformationIndex)
  }, [indexInfo?.TransformationIndex])

  const onSubSelect = (index: number, transformation: TTransformation) => {
    setSubSelected(index);
    if (setIndex)
    setIndex((prev)=>{
      let newState = {...prev,
        TransformationIndex: index}
        return newState
        }
        );
    setSubSelectedItem(transformation);
  };

  return (
    <div id={id}>
      <div
        id={`${id}-main`}
        onClick={() => {
          onSelect();
          setSubSelected(null);
          setSubSelectedItem(null);
        }}
        className={`tw-rounded tw-cursor-pointer tw-bg-shades-of-grey-0 tw-box-border tw-w-auto tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-[12px] tw-border-[1px] tw-border-solid ${
          isSelected
            ? "tw-border-primary tw-text-primary"
            : "tw-border-shades-of-grey-30 tw-text-shades-of-grey-60"
        }`}
      >
        <div id={`${id}-content`} className="tw-flex tw-justify-start tw-items-center">
          {classColor ? (
            <div
              id={`${id}-color-bar`}
              style={{ backgroundColor: classColor }}
              className="tw-w-[5px] tw-h-[42px] tw-rounded-tl-[3px] tw-rounded-bl-[3px]"
            />
          ) : null}
          <div id={`${id}-info`} className="tw-px-3 tw-py-[3px]">
            <label id={`${id}-name`} className="tw-text-xs tw-block">{fieldName}</label>
            <div id={`${id}-details`} className="tw-flex tw-items-center tw-gap-2">
              <label id={`${id}-type`} className="tw-text-xs tw-text-[#747593] tw-block">
                {fieldType}
              </label>
              {showCalculatedField && showCalculatedField ? (
                <div id={`${id}-calculated-badge`} className="tw-w-[67px] tw-h-4 tw-px-1 tw-bg-orange-100 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                  <div id={`${id}-calculated-text`} className="tw-text-yellow-700 tw-text-xs tw-font-normal">
                    {CALCULATED}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div id={`${id}-delete-menu`}>
          <DeleteDataModel
            onContextMenuOptionClick={handleContextMenuOptionClick}
          />
        </div>
      </div>

      {isSelected &&
        [PRODUCT_CATEGORY, TRANSFORMATION].includes(fieldType) &&
        field?.data?.transformations &&
        field.data.transformations.map(
          (transformation: TTransformation, index: number) => (
            <div
              id={`${id}-transformation-${index}`}
              key={index}
              className="tw-flex tw-justify-start tw-w-auto tw-ms-2"
              onClick={() => {
                onSubSelect(index, transformation);
              }}
            >
              <LIcon />
              <div
                id={`${id}-transformation-content-${index}`}
                className={`tw-mt-2 tw-rounded tw-cursor-pointer tw-bg-white tw-box-border tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-between tw-py-[3px] tw-px-3 tw-gap-[12px] tw-border-[1px] tw-border-solid tw-text-shades-of-grey-60 ${
                  subSelected === index
                    ? "tw-border-primary tw-text-primary"
                    : "tw-border-shades-of-grey-30 tw-text-shades-of-grey-60"
                }`}
              >
                <div id={`${id}-transformation-info-${index}`}>
                  <label id={`${id}-transformation-name-${index}`} className="tw-text-xs tw-block tw-italic tw-font-medium tw-text-shades-of-grey-40">
                    {transformation.name}
                  </label>
                  <label id={`${id}-transformation-type-${index}`} className="tw-text-xs tw-italic tw-text-[#97A0AF] tw-block">
                    {transformation.type}
                  </label>
                </div>
                <div id={`${id}-transformation-delete-${index}`}>
                  <DeleteDataModel
                    onContextMenuOptionClick={()=>handleContextMenuTransformationOptionClick(transformation?.id as string)}
                  />
                </div>
              </div>
            </div>
          )
        )}
    </div>
  );
};

export default ProductCategoryItem;
